export default "__VITE_ASSET__DqiahjDr__"